/* ─── Root ─── */

.root {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.root[data-disabled] {
  opacity: 0.38;
  cursor: not-allowed;
}

/* ─── Label ─── */

.label {
  font: var(--type-label-lg);
  letter-spacing: var(--tracking-label-lg);
  font-family: var(--font-sans);
  color: var(--md-on-surface);
}

.root[data-invalid] .label {
  color: var(--md-error);
}

/* ─── Group (outlined border wrapper) ─── */

.group {
  display: flex;
  align-items: stretch;
  height: 3rem;
  border: 1px solid var(--md-outline);
  border-radius: var(--shape-xs);
  overflow: hidden;
  transition: border-color var(--motion-duration-short3)
      var(--motion-easing-standard),
    box-shadow var(--motion-duration-short3) var(--motion-easing-standard);
}

.group:focus-within {
  border-color: var(--md-primary);
  box-shadow: 0 0 0 1px var(--md-primary);
}

.root[data-invalid] .group {
  border-color: var(--md-error);
}

.root[data-invalid] .group:focus-within {
  border-color: var(--md-error);
  box-shadow: 0 0 0 1px var(--md-error);
}

/* ─── Input ─── */

.input {
  font: var(--type-body-lg);
  letter-spacing: var(--tracking-body-lg);
  all: unset;
  flex: 1;
  min-width: 0;
  padding-inline: var(--space-3);
  font-family: var(--font-sans);
  color: var(--md-on-surface);
}

.input::placeholder {
  color: var(--md-on-surface-variant);
}

.root[data-disabled] .input {
  cursor: not-allowed;
}

/* ─── Steppers container ─── */

.steppers {
  display: flex;
  flex-direction: column;
  border-inline-start: 1px solid var(--md-outline-variant);
}

/* ─── Step buttons ─── */

.stepBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  width: 2rem;
  padding: 0;
  border: none;
  background: var(--md-surface-container-high);
  color: var(--md-on-surface);
  cursor: pointer;
  transition: background var(--motion-duration-short3)
    var(--motion-easing-standard);
}

@media (hover: hover) {
  .stepBtn:hover {
    background: var(--md-surface-container-highest);
  }
}

.stepBtn:disabled {
  cursor: not-allowed;
  color: var(--md-disabled-content);
}

.stepBtn + .stepBtn {
  border-block-start: 1px solid var(--md-outline-variant);
}

.stepBtn svg {
  width: 0.75rem;
  height: 0.75rem;
}

/* ─── Description ─── */

.description {
  font: var(--type-body-lg);
  letter-spacing: var(--tracking-body-lg);
  font-family: var(--font-sans);
  color: var(--md-on-surface-variant);
  margin: 0;
}

/* ─── Error ─── */

.error {
  font: var(--type-body-lg);
  letter-spacing: var(--tracking-body-lg);
  font-family: var(--font-sans);
  color: var(--md-error);
  margin: 0;
}
